import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';
import config from 'src/config';

export const spotlightApiClient = axios.create({
  baseURL: config.spotlightApiGatewayBaseUrl,
});

spotlightApiClient.interceptors.request.use(async (requestConfig) => {
  const { tokens } = await fetchAuthSession();
  const idToken = tokens?.idToken?.toString();
  requestConfig.headers.Authorization = idToken;
  requestConfig.headers['Content-Type'] = 'application/json';
  return requestConfig;
});
